export const SET_TEAM_DATA = "SET_TEAM_DATA";
export const USER_FETCHING_INIT = "USER_FETCHING_INIT";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_ROLES = "SET_USER_ROLES";
export const USER_FETCHING_DISMISS = "USER_FETCHING_DISMISS";

const initialState = {
  //new user params
  nU_name: "",
  nU_email: "",
  nU_phone: "",
  nU_role: "",
  nU_error: "",
  //edit user params
  eU_name: "",
  eU_email: "",
  eU_phone: "",
  eU_role: "",
  eU_role_id: "",
  eU_error: "",
  eU_company_position: "",
  eU_qualification: "",
  eU_department: "",
  eU_reporting_manager: "",
  eU_reporting_manager_status: false,
  eU_user_role: "",
  organisation_team_limit: {
    admin_left: 0,
    user_left: 0,
  },
  user_roles: [],
  partner_roles: [],
  user_list: [], //holds user list array
  userlist_fetching: false, //indicaction for fetch in progress
  userlist_refetch: false, //indication to refetch current user list array
  userlist_refetch_force: false, //indication to force refetch user list array from beginning
  edit_user: null, //holds initial data of user being edited
  show_add_team_modal: false,
  disable_team_add_btn: false,
  delete_team_member: null,
  del_btn_disable: false,
  team_logo_dlt: false,
  add_team_otp_popup: false,
  add_team_otp_resend_enable: true,
  add_team_otp: "",
  belongs_to: true,
  reporting_manager: "",
  resend_invitation_popup: false,
  org_resend_enable: true,
  delete_user: null, //holds initial data of user opted to be deleted
  disable_user: null, //holds initial data of user opted to be disabled,
  search: "", //search keyword on user listing
  page: 1, //page number on user listing
  perpage: 20, //perpage limit on user listing
  total_users: 0, //total count
  isDataLoading: true,

  show_add_team_partner_modal: false,
  disable_team_partner_add_btn: false,
  allRoles: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TEAM_DATA: {
      return { ...state, ...action.payload };
    }
    case USER_FETCHING_INIT: {
      return {
        ...state,
        userlist_fetching: true,
        userlist_refetch: false,
        userlist_refetch_force: false,
      };
    }
    case USER_FETCHING_DISMISS: {
      return { ...state, userlist_fetching: false };
    }
    case SET_USER_ROLES: {
      return { ...state, user_roles: action.payload };
    }
    default:
      return state;
  }
};
